window.saveAsb26BundleDetailsToCartAttributes = async function (formElement, productId) {
  if (!productId) return;

  const summaryContainer = formElement.querySelector('.bundle-summary-items');
  if (!summaryContainer) return;

  const linesByType = {};
  summaryContainer.querySelectorAll('.summary-item').forEach((sectionEl) => {
    if (sectionEl.classList.contains('summary-total') || sectionEl.style.display === 'none') return;

    const typeClass = Array.from(sectionEl.classList).find(
      (className) => className.startsWith('summary-') && className !== 'summary-item'
    );
    if (!typeClass) return;

    let type = typeClass.replace('summary-', '');
    if (type === 'room') type = 'hotel';

    const lines = Array.from(sectionEl.querySelectorAll('p'))
      .map((paragraph) => paragraph.textContent.trim())
      .filter(Boolean);

    if (lines.length) {
      linesByType[type] = (linesByType[type] || []).concat(lines);
    }
  });

  const attributes = {};
  ['ingresso', 'hotel', 'noites', 'voo', 'pacote'].forEach((type) => {
    attributes[`bundle_${productId}_${type}`] = (linesByType[type] || []).join(' | ');
  });

  await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes })
  });
};
